import { Outlet } from "react-router-dom";
import { Footer } from "./footer";
import { Header } from "./header";

export function MarketingLayout({ children }: { children?: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Header />
      <main className="flex-1">{children ?? <Outlet />}</main>
      <Footer />
    </div>
  );
}
